<style src="./EventDocuments.scss" lang="scss"></style>
<template>
  <main class="event-documents">
    <content-header path="Documentos" />

    <section class="row documentcontent">
      <section class="col-8">
        <item-documents />
      </section>

      <section class="col-4">
        <document-upload />
      </section>
    </section>
  </main>
</template>

<script>
import ContentHeader from "@/components/foundation/content-header/ContentHeader";
import DocumentUpload from "./components/document-upload/DocumentUpload";
import ItemDocuments from "./components/item-documents/ItemDocuments";

export default {
  name: "EventDocuments",
  components: {
    ContentHeader,
    ItemDocuments,
    DocumentUpload
  },
  data: () => ({
    eventDetails: {
      date: null
    },
    documents: [],
    items: []
  }),
  mounted() {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/view/event-documents/EventDocuments.vue